import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20with%20dramatic%20warm%20golden%20spotlights%20and%20soft%20amber%20glow%2C%20abstract%20elegant%20curtains%20with%20rich%20crimson%20and%20gold%20accents%2C%20luxurious%20cinema%20atmosphere%2C%20clean%20composition%2C%20professional%20theater%20photography%2C%20deep%20blacks%20with%20warm%20lighting&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="91在线观看 - 高清视频免费播放平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
          海量高清视频，<span className="text-primary-400">永久免费</span>观看
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚热门影视、综艺、动漫、纪录片，无需下载，即点即看。随时随地，畅享优质娱乐资源。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/25 border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000万+</p>
            <p className="text-xs text-background-300 mt-1">月活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">30万+</p>
            <p className="text-xs text-background-300 mt-1">视频资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.9%</p>
            <p className="text-xs text-background-300 mt-1">播放成功率</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}